/**
 * Google Translate DOM reconciliation guard.
 *
 * When Chrome's Google Translate rewrites the page it swaps text nodes for its
 * own <font> wrappers. React keeps references to the original text nodes, so on
 * the next re-render its calls to `removeChild` / `insertBefore` target nodes
 * whose parent has silently changed, throwing:
 *
 *   Uncaught NotFoundError: Failed to execute 'insertBefore' on 'Node':
 *   The node before which the new node is to be inserted is not a child of this node.
 *
 * ...which crashes the whole app into a blank page.
 *
 * These patches make both methods no-op safely when the parent no longer matches
 * instead of throwing, letting React recover on the next render. See the
 * long-standing facebook/react issue #11538.
 */
if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function removeChild(child) {
    if (child.parentNode !== this) {
      if (console) {
        console.warn('Cannot remove a child from a different parent', child, this);
      }
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function insertBefore(newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (console) {
        console.warn('Cannot insert before a reference node from a different parent', referenceNode, this);
      }
      return newNode;
    }
    return originalInsertBefore.apply(this, arguments);
  };
}
